function trackEvent(eventCategory, eventDetails, testId) {
  window.Shopify?.analytics?.publish?.('AB_Test_Event', {
    AB_Event_Data_1: eventCategory,
    AB_Event_Data_2: eventDetails,
    AB_Event_Data_Test_ID: testId,
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // This theme acts as "Control", so we shouldn't have any tracking in it. Visit the baseline or v1 branches instead
  //   trackEvent('User Engagement', 'ASC-003 - Session Capture', 'ASC-003');
  //   trackEvent(
  //     'User Engagement',
  //     'ASC-003 - Session Capture (Variation 1)',
  //     'ASC-003',
  //   );
  //   trackEvent('User Engagement', 'ASC-003 - Variation 1', 'ASC-003');
  //   const isSeoPge = document.body.classList.contains('page-combo-landing-page');
  //   if (isSeoPge) {
  //     trackEvent('User Engagement', 'ASC-003 - SEO Page Viewed', 'ASC-003');
  //   }
});
